import defaultAttributes from '../defaultAttributes';

const Axe = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d:
          'M14 12l-8.501 8.501a2.12 2.12 0 01-2.998 0h-.002a2.12 2.12 0 010-2.998L11 9.002',
      },
    ],
    [
      'path',
      { d: 'M9 7l4-4 6 6h3l-.13.648a7.648 7.648 0 01-5.081 5.756L15 16v-3z' },
    ],
  ],
];

export default Axe;
